export default "__VITE_ASSET__Y2EUBAxE__"